/**
 * Role name carried in `AdornisUser.roles`. Only the name is stored — `permissions` on the
 * wrapper stays empty, so `hasPermission()` does not apply; we match on the name.
 */
export const USER_ADMIN_ROLE = 'Admin';
